module.exports = __webpack_public_path__ + "static/media/1.8f91dea7.jpg";